import { render, staticRenderFns } from "./PrefectureSelectBox.vue?vue&type=template&id=449aa0fb&"
import script from "./PrefectureSelectBox.vue?vue&type=script&lang=ts&"
export * from "./PrefectureSelectBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports